import React, {useMemo} from 'react';
import {useConstCallback} from '@netx/core-components/hooks/useConstCallback';
import {type ReactAction} from '@netx/core/bootstrap';
import {ActionListItem, type ActionListItemProps} from './ActionListItem';

export interface ActionListProps {
	actions: Array<ReactAction | ReactAction[]>;
	disabled?: boolean;
	loading?: boolean;
}

export const renderActions = ({
	actions,
	disabled,
	loading,
}: ActionListProps) => {
	const _actions = useMemo(() => actions.flat(), [actions]);

	const renderAction = useConstCallback((action: ReactAction) => {
		return (
			<ActionListItem
				key={`action-menu-item-${action.name}`}
				action={action}
				disabled={disabled}
				loading={loading}
			/>
		);
	});

	return _actions.map((action) => {
		return renderAction(action);
	});
};

export const ActionList = (props: ActionListProps) => {
	return <>{renderActions(props)}</>;
};

export default ActionList;
